import React from 'react';

export default function Footer() {
  return (
    <div className="copyright nounderline">
      &copy; Brixton Ramblers Lodge #3347. All rights reserved.
    </div>
  );
}
